import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { RecaptchaActions } from './recaptcha.actions';
import { SafeSendActions } from '../safe-send/safe-send.actions';
import { UserInputActions } from '../user-input/user-input.actions';
import { RecaptchaService } from '../../services/recaptcha.service';
import { selectSessionIdentifier } from '../va-session/va-session.reducer';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaEffects {
  constructor(
    private actions$: Actions,
    private recaptchaService: RecaptchaService,
    private store: Store
  ) {}

  prepareSafeSendAfterRecaptcha$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RecaptchaActions.setRecaptcha),
      switchMap((action) => {
        const toProceed = action.isResolved || action.isError;
        if (toProceed) {
          return of(SafeSendActions.prepareSafeSend());
        } else {
          return of(UserInputActions.disableUserInput());
        }
      })
    )
  );

  checkRecaptcha$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RecaptchaActions.checkRecaptcha),
      concatLatestFrom(() => this.store.select(selectSessionIdentifier)),
      switchMap(([, sessionId]) =>
        this.recaptchaService.validateCaptcha(sessionId).pipe(
          map(() =>
            RecaptchaActions.setRecaptcha({
              isResolved: true,
              isError: false,
            })
          ),
          catchError((err) => {
            if (err.status === 403) {
              // If 403 that means user is not human
              return of(
                RecaptchaActions.setRecaptcha({
                  isResolved: false,
                  isError: false,
                })
              );
            }
            // If any other error, that means there is a problem with the service
            return of(
              RecaptchaActions.setRecaptcha({
                isResolved: false,
                isError: true,
              })
            );
          })
        )
      )
    )
  );
}
